import { render, staticRenderFns } from "./NewMessageChatSummary.vue?vue&type=template&id=4ec0414e&scoped=true"
import script from "./NewMessageChatSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewMessageChatSummary.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NewMessageChatSummary.vue?vue&type=style&index=0&id=4ec0414e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0414e",
  null
  
)

export default component.exports